.container {
  flex: 1;
  display: flex;
  min-height: 100%;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.content {
  z-index: 1;
}
